import React, { Component } from "react";
import axios from "../../axios";
import Alert from "react-s-alert";
import FormDropdown from "../../components/FormDropdown";
import { status_aktif } from "../../constants/general";
import qs from "qs";
import { FOTO_EVENT_HOST } from "../../constants/siteConfig";
import DropdownView from "./DropdownView";
import DatePicker from "react-datepicker";
import moment from "moment";
import Cropper from "react-crop";
import "react-crop/cropper.css";

class FormPresensiSiswa extends Component {
	constructor(props) {
		super(props);

		this.state = {
			kelas_id:"",
			siswa_id:"",
			keterangan:"",
			status:"",
			presensi_id:"",
			status_izin:"",
			dataKelas :[],
			dataSiswa :[],
			event_mulai_moment: null,
			event_mulai:"",
			isButtonLoading: false,
			isLoading: false,
			defaultImg:"./noimage.gif",
			imageCrop:null,
			event_foto:""
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleChangeKelas = this.handleChangeKelas.bind(this);
		this.handleChangeSiswa = this.handleChangeSiswa.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleDatepickerStartChange = this.handleDatepickerStartChange.bind(this);
	}

	handleDatepickerStartChange(date) {
		if (date !== null) {
			this.setState({
				event_mulai_moment: date,
				event_mulai: date.format("YYYY-MM-DD")
			});
		} else {
			this.setState({ event_mulai: "" });
		}
	}

	handleChange(event) {
		const target = event.target;
        const value  = target.value;
		const name   = target.name;
		
		if (value == 'not_taken') {
			this.setState({
				status_izin:""
			})
		}
		this.setState({
			[name]: value
		})      
	}

	handleSubmit() {
		let formData = new FormData();

		const config = {
			headers: { "content-type": "multipart/form-data" }
		};
		formData.append("siswa_id", this.state.siswa_id);
		formData.append("keterangan", this.state.keterangan);
		formData.append("status", this.state.status);
		// formData.append("event_foto", this.state.imageCrop);
		formData.append("status_izin", this.state.status_izin);
		formData.append("event_mulai", this.state.event_mulai);
		formData.append("presensi_id", this.state.presensi_id);


		const url = this.props.mode === "Tambah" ? "tambah_presensi_siswa" : "edit_presensi_siswa";

		this.setState({ isButtonLoading: true });

		axios
			.post(url, formData, config)
			.then(response => {
				const result = response.data;

				if (result.success) {
					Alert.success(result.message);
					this.props.history.replace("/reportpresensi/siswa");
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
							Alert.error(item);

							return true;
						});
					} else {
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			});
	}


	onChange(evt) {
		this.setState({
			previewImg: null,
			defaultImg: null,
			imageCrop: null,
			image: evt.target.files[0],
			event_foto: ""
		});
	}

	async crop() {
		let image = await this.refs.crop.cropImage();

		this.setState({
			previewImg: window.URL.createObjectURL(image),
			defaultImg: null,
			event_foto: window.URL.createObjectURL(image),
			imageCrop: image
		});
	}

	imageLoaded(img) {
		if (
			img.naturalWidth &&
			img.naturalWidth < 262 &&
			img.naturalHeight &&
			img.naturalHeight < 147
		) {
			this.crop();
		}
	}


	clear() {
		this.refs.file.value = null;
		this.setState({
			previewImg: null,
			defaultImg: "./noimage.gif",
			image: null,
			imageCrop: null,
			event_foto: ""
		});
	}



	handleChangeKelas(event) {
		const target = event.target;
        const value  = target.value;
        const name   = target.name;
        this.setState({
            [name] : value,
		})
		
		this.loadDataSiswa(value);
	}

	handleChangeSiswa(event) {
		const target = event.target;
        const value  = target.value;
		const name   = target.name;
		
		
        this.setState({
            [name] : value,
		})
		
	}

	loadDataSiswa(value){
		const params = qs.stringify({
			kelas_id:value
		})
		axios({
			method: "post",
			url: "/siswa_data?" + params
		})
        .then(response => {
            return response.data.data.map(item => ({
                key: item.siswa_id,
                value : item.user_nama
            }))
        })
        .then(result => {
            this.setState({
                dataSiswa: result
            })
        })
        .catch(error => {
            console.log("Kelas Undefinded")
        })
	}
	
	loadData() {
		
			this.setState({ isLoading: true });
			
			const params = qs.stringify({
				presensi_id:this.props.match.params.presensi_id,
				siswa_id:this.props.match.params.siswa_id
			})
			
			axios({
				method: "post",
				url: "/edit_data_presensi?" + params
			})
			
			.then(response => {
				const result = response.data;

				if (result.success) {
						
					this.setState({
                        siswa_id: result.data.user.siswa_id,
                        kelas_id: result.data.user.kelas_id,
						username: result.data.user.user_nama,
						event_mulai_moment: moment(result.data.presensi[0].presensi_create_date),
						presensi_id: result.data.presensi[0].presensi_id,
                        keterangan: result.data.presensi[0].keterangan,
                        status: result.data.presensi[0].presensi_status,
                        status_izin: result.data.presensi[0].status_izin,
                        event_mulai: result.data.presensi[0].presensi_create_date,
						isLoading: false
						
						// previewImg:
						// 		result.data.presensi[0].tanda_bukti !== null
						// 			? FOTO_EVENT_HOST + result.data.presensi[0].tanda_bukti
						// 			: "./noimage.gif",
						// 	defaultImg: result.data.presensi[0].tanda_bukti !== "" ? null : "./noimage.gif"
                    });
					// this.setState(newState);
					this.loadDataSiswa(result.data.user.kelas_id)

				} else {
					Alert.error(result.message);
				}

				this.setState({ isLoading: false });
			})
			.catch(error => {
				console.log(error);
				Alert.error("Data Tidak Ditemukan");
				this.setState({ isLoading: false });
			});
	}

	loadDataKelas(){
        axios.post("/kelas")
        .then(response => {
            return response.data.data.map(item => ({
                key: item.kelas_id,
                value : item.kelas_nama
            }))
        })
        .then(result => {
            this.setState({
                dataKelas: result
            })
        })
        .catch(error => {
            console.log("Kelas Undefinded")
        })
    }

	componentDidMount() {
		this.loadData();
        this.loadDataKelas();

	}

	render() {
		return (
			
			<div className="col-sm-12">
				<div className="card" >
					<div className="card-header">Form Izin</div>
					<div className="card-block">
						{this.state.isLoading ? (
							"Memuat Data..."
						) : (
							<div className="form-horizontal animated fadeIn">
								<div className="form-group row">
									
									<div className="col-md-12">
										<div className="form-group row"
											name="presensi_id"
											value={this.state.presensi_id}>
												
											<label className="col-md-2 form-control-label">
												Kelas
											</label>
											<div className="col-md-10">
												
												<FormDropdown
													items = {this.state.dataKelas}
													onChange = {this.handleChangeKelas}
													value={this.state.kelas_id.toString()}
													placeholder={"Pilih Kelas"}
													name="kelas_id"
													disabled
												/>
			                                </div>
			                            </div>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">
													Nama Siswa
												</label>
												<div className="col-md-10">
												<FormDropdown
													items = {this.state.dataSiswa}
													onChange = {this.handleChangeSiswa}
													value={this.state.siswa_id.toString()}
													placeholder={"Pilih Siswa"}
													name="siswa_id"
													disabled
												/>
												</div>
											</div>
												<DropdownView
													handleChange={this.handleChange}
													stateName="status"
													label="Status"
													items={[
														{ key: "absent", value: "Izin" },
														{ key: "not_taken", value: "Alpha" }
													]}
													value={this.state.status}
												/>

										{this.state.status === ''?(
											""
										):(
											this.state.status !=='not_taken'?(
													<DropdownView
														handleChange={this.handleChange}
														stateName="status_izin"
														label="Status Izin"
														items={[
															{ key: "1/2hari", value: "1/2 Hari" },
															{ key: "acara_keluarga", value: "Acara Keluarga" },
															{ key: "sakit", value: "Sakit" },
															{ key: "acara_sekolah", value: "Acara Sekolah" },
															{ key: "lain_lain", value: "Lain-Lain" }
														]}
														value={this.state.status_izin}
													/>
											) : ""
										)}

											
										
										<div className="form-group row">
											<label className="col-md-2 form-control-label">
												Keterangan
											</label>
											<div className="col-md-10">
												<textarea
													label="keterangan"
													name="keterangan"
													className="form-control"
													placeholder="Ketik keterangan disini ..."
													onChange={this.handleChange}
													value={this.state.keterangan}
													style={{ marginBottom: 10 }}
												/>

													{/* <div className="col-md-5">
														<label className="btn btn-info" style={{ cursor: "pointer" }}>
															Choose Image ...
															<input
																ref="file"
																type="file"
																onChange={this.onChange.bind(this)}
																hidden
															/>
														</label>{" "}
														&nbsp;
														{this.state.previewImg && (
															<label onClick={this.clear.bind(this)} className="btn btn-danger" style={{ cursor: "pointer" }}>
																Clear
															</label>
														)}
														{this.state.defaultImg && (
															<div>
																<img
																	src={this.state.defaultImg}
																	className="img-thumbnail"
																	style={{ width: "320px", height: "180px" }}
																	alt=""
																/>
															</div>
														)}
														{this.state.previewImg && (
															<div>
																<img
																	src={this.state.previewImg}
																	className="img-thumbnail"
																	style={{ width: "320px", height: "180px" }}
																	alt=""
																/>
															</div>
														)}
														{this.state.image &&
															!this.state.previewImg && (
																<div>
																	<Cropper
																		ref="crop"
																		image={this.state.image}
																		width={320}
																		height={180}
																		onImageLoaded={this.imageLoaded.bind(this)}
																	/>
																	<button
																		onClick={this.crop.bind(this)}
																		className="btn btn-md btn-success"
																	>
																		Crop
																	</button>
																	&nbsp;
																	<button
																		onClick={this.clear.bind(this)}
																		className="btn btn-md btn-danger"
																	>
																		Clear
																	</button>
																</div>
															)}
													</div> */}

											</div>
										</div>
										
										<div className="form-group row">
											<label className="col-md-2 form-control-label">
												Tanggal Mulai
											</label>
											<div className="col-md-4">
												
												<DatePicker
													disabled
													selected={this.state.event_mulai_moment}
													selectsStart
													startDate={this.state.event_mulai_moment}
													endDate={this.state.event_selesai_moment}
													onChange={this.handleDatepickerStartChange}
													dateFormat="DD-MM-YYYY"
													withPortal
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
					<div className="card-footer">
						<button
							type="button"
							className="btn btn-md btn-primary"
							disabled={this.state.isButtonLoading && "disabled"}
							onClick={this.handleSubmit}
						>
							{this.state.isButtonLoading ? "Loading" : "Simpan"}
						</button>{" "}
						<button
							type="button"
							className="btn btn-md btn-danger"
							disabled={this.state.isButtonLoading && "disabled"}
							onClick={() => this.props.history.goBack()}
						>
							Batal
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default FormPresensiSiswa;



// WEBPACK FOOTER //
// ./src/views/ReportPresensi/FormEditPresensiSiswa.js